module.exports = {
  ...require('./valueSchedules'),
  ...require('./wages'),
  ...require('./time')
};